import { DUR, EASE } from '@/animations/vars'
import { gsap } from '@gsap'

const animateNav = (comp: any, tl: any) => {
  tl.current = gsap.timeline({
    paused: true,
    defaults: {
      duration: DUR.default * 0.8,
      ease: EASE.expoOut
    }
  })
  const body = document.querySelector('body')
  const _mainWrap = document.querySelector('[data-main]')
  const item = '[data-item="true"]'
  gsap.set(item, { y: '1rem', autoAlpha: 0 })
  gsap.set(comp.current, { yPercent: -100 })
  tl.current
    .to(body, { overflow: 'hidden', duration: 0 })
    .to(comp.current, { yPercent: 0, duration: 0.8 }, '<')
    .to(item, { y: 0, autoAlpha: 1, stagger: 0.1 }, '<0.3')
}

export default animateNav
